export { default as QuickAddSize } from './quickAddSize'



// WEBPACK FOOTER //
// ./src/components/productTile/quickAdd/index.js